module.exports = __webpack_public_path__ + "static/images/challenge.3307141184aa305f8db1df8fe8e6caaf.jpg";